@if (withoutCredits()) {
  <ion-list class="block-content-round no-padding ion-margin-bottom">
    <ion-item-group class="bg-warning">
      <ion-item-divider sticky>
        <ion-icon
          slot="start"
          aria-hidden="true"
          src="../assets/material-symbols/warning_24dp.svg"
          class="txt-warning"
        ></ion-icon>
        <div>
          <p class="subtitle txt-warning">No tiene créditos</p>
        </div>
      </ion-item-divider>
      <div class="detail-group">
        <p class="ion-text-center fs-sm ion-padding">
          <strong>No tiene créditos suficientes para generar un nuevo documento de control.</strong> Por favor, póngase
          en contacto con nosotros para recargar su cuenta.
        </p>
        <div class="ion-text-center ion-padding-bottom">
          <ion-button
            fill="solid"
            target="_blank"
            rel="noopener noreferrer"
            [href]="buyCreditsUrl"
          >
            Comprar créditos DeCA
          </ion-button>
        </div>
      </div>
    </ion-item-group>
  </ion-list>
}

@if (formSignal(); as form) {
  <form
    [formGroup]="form"
    (ngSubmit)="onSubmit()"
  >
    <ion-list class="block-content-round no-padding">
      <ion-grid class="">
        <ion-row class="ion-no-padding">
          <ion-col
            size="12"
            class="ion-no-padding"
          >
            <ion-item-group data-form-section>
              <ion-item-divider sticky>
                <ion-icon
                  slot="start"
                  aria-hidden="true"
                  src="../assets/material-symbols/description_24dp.svg"
                ></ion-icon>
                <div>
                  <p class="subtitle">Datos generales del documento</p>
                </div>
              </ion-item-divider>
              <div class="detail-group">
                <ion-grid>
                  <ion-row>
                    <ion-col
                      size-lg="4"
                      size="12"
                    >
                      <ion-input
                        formControlName="reference"
                        type="text"
                        label="Referencia interna"
                        labelPlacement="floating"
                        fill="outline"
                        mode="md"
                      ></ion-input>
                    </ion-col>

                    @if (isServiceStarted()) {
                      <ion-col
                        size-lg="8"
                        size="12"
                      >
                        <lib-deca-edit-reason [form]="form.controls.changeReason"></lib-deca-edit-reason>
                      </ion-col>
                    }
                  </ion-row>
                </ion-grid>
              </div>
            </ion-item-group>

            @if (form.controls.shipper) {
              <ion-item-group data-form-section>
                <ion-item-divider sticky>
                  <ion-icon
                    slot="start"
                    aria-hidden="true"
                    src="../assets/material-symbols/box_24dp.svg"
                  ></ion-icon>
                  <div>
                    <p class="subtitle">Cargador contractual</p>
                  </div>
                </ion-item-divider>

                <div class="detail-group">
                  @if (isServiceStarted()) {
                    <p class="fs-sm ion-padding-horizontal">
                      No se pueden realizar un cambio de transportista o cargador si el servicio de transporte ya se ha
                      iniciado
                    </p>
                  }

                  <lib-deca-edit-company
                    [form]="form.controls.shipper"
                    [locationData]="shipperLocation()"
                    [companyRole]="DECA_ROLE.SHIPPER"
                    [viewMode]="shipperMode()"
                    [readOnly]="isServiceStarted()"
                    (locationChange)="shipperLocation.set($event)"
                    (modeChange)="shipperMode.set($event)"
                    (setManualMode)="shipperMode.set('manual')"
                  ></lib-deca-edit-company>
                </div>
              </ion-item-group>
            }

            @if (form.controls.carrier) {
              <ion-item-group data-form-section>
                <ion-item-divider sticky>
                  <ion-icon
                    slot="start"
                    aria-hidden="true"
                    src="../assets/material-symbols/local_shipping_24dp.svg"
                  ></ion-icon>
                  <div>
                    <p class="subtitle">Transportista efectivo</p>
                  </div>
                </ion-item-divider>

                <div class="detail-group">
                  @if (isServiceStarted()) {
                    <p class="fs-sm ion-padding-horizontal">
                      No se pueden realizar un cambio de transportista o cargador si el servicio de transporte ya se ha
                      iniciado
                    </p>
                  }

                  <lib-deca-edit-company
                    [form]="form.controls.carrier"
                    [locationData]="carrierLocation()"
                    [companyRole]="DECA_ROLE.CARRIER"
                    [viewMode]="carrierMode()"
                    [readOnly]="isServiceStarted()"
                    (locationChange)="carrierLocation.set($event)"
                    (modeChange)="carrierMode.set($event)"
                    (setManualMode)="carrierMode.set('manual')"
                  ></lib-deca-edit-company>
                </div>
              </ion-item-group>
            }

            <ion-item-group data-form-section>
              <ion-item-divider sticky>
                <ion-icon
                  slot="start"
                  aria-hidden="true"
                  src="../assets/material-symbols/local_shipping_filled_24dp.svg"
                ></ion-icon>
                <div>
                  <p class="subtitle">Medios de transporte</p>
                </div>
              </ion-item-divider>
              <div class="detail-group">
                <ion-grid>
                  <ion-row>
                    <ion-col
                      size-lg="2"
                      size="12"
                    >
                      <ion-input
                        formControlName="tractorPlateNumber"
                        type="text"
                        label="Matrícula vehículo tractor"
                        labelPlacement="floating"
                        fill="outline"
                        mode="md"
                        placeholder="Ej. 1234FGH"
                        errorText="Obligatorio"
                      ></ion-input>
                    </ion-col>
                    <ion-col
                      size-lg="2"
                      size="12"
                    >
                      <ion-input
                        formControlName="trailerPlateNumber"
                        type="text"
                        label="Matrícula remolque"
                        labelPlacement="floating"
                        fill="outline"
                        mode="md"
                        placeholder="Ej. R5678FGH"
                        errorText="Obligatorio"
                      ></ion-input>
                    </ion-col>
                    <ion-col
                      size-lg="3"
                      size="12"
                    >
                      <ion-item
                        lines="none"
                        class=""
                      >
                        <ion-toggle
                          formControlName="hasSpecialAuthorization"
                          labelPlacement="end"
                        >
                          ¿Autorización especial?
                        </ion-toggle>
                      </ion-item>
                    </ion-col>

                    <ion-col
                      size-lg="5"
                      size="12"
                    >
                      @if (hasSpecialAuthorization()) {
                        <ion-input
                          formControlName="specialAuthorizationType"
                          type="text"
                          label="Autorización"
                          labelPlacement="floating"
                          fill="outline"
                          mode="md"
                          errorText="Obligatorio"
                        ></ion-input>
                      }
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </div>
            </ion-item-group>

            <!-- Tramos (Segments) -->
            @for (segmentGroup of form.controls.segments.controls; track $index) {
              <lib-deca-edit-segment
                [form]="segmentGroup"
                [index]="$index"
                [totalSegments]="form.controls.segments.length"
                [initialOriginLocation]="segmentLocations()[$index]?.originLocation ?? null"
                [initialDestinationLocation]="segmentLocations()[$index]?.destinationLocation ?? null"
                [previousAddressData]="previousDestinationDataList()[$index]"
                (locationChange)="handleSegmentLocationChange($index, $event)"
                (removeSegment)="removeSegment($index)"
              ></lib-deca-edit-segment>
            }

            @if (form.controls.segments.length < maxSegments) {
              <div class="ion-padding ion-text-center">
                <ion-button
                  fill="outline"
                  type="button"
                  (click)="addSegment()"
                  [disabled]="withoutCredits()"
                >
                  <ion-icon
                    slot="start"
                    src="../assets/material-symbols/add_24dp.svg"
                  ></ion-icon>
                  Añadir tramo ({{ form.controls.segments.length }}/{{ maxSegments }})
                </ion-button>
              </div>
            }
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-list>

    @if (!isSmDown()) {
      <div class="ion-padding ion-margin-top ion-text-center">
        <ion-button
          expand="block"
          type="submit"
          size="large"
          [disabled]="withoutCredits()"
        >
          <ion-icon
            slot="start"
            src="../assets/material-symbols/save_24dp.svg"
          ></ion-icon>
          Guardar documento
        </ion-button>
      </div>
    }
  </form>
}
